/* global $:true */
import plugin from '../../lib/plugin';
import { onAvailable } from "../../lib/selectors";

const ELEMENT_SELECTOR = '[data-tabs-controller]';
const PLUGIN_NAME = 'tabsController';

export function exec() {
	onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		System.import(
			/* webpackChunkName: "plugin--tabs-controller" */ "./tabs-controller"
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/tabs/index.js